import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import transport from './modules/transport'
import fee from './modules/fee'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        transport,
        fee
    },
    getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js